<script>
	import Pagination from "../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import { convert } from "src/services/helpers";
	import { damageReviewed, totalRecords } from "src/store/store";
	import { verdictOptions } from "src/utils/options";
	import { navigate } from "svelte-routing";
	import { Table } from "sveltestrap";

	let sortDateReported = 1;
	let numColumn = -1;

	let sort = {
		sortCol: "",
		sortDir: "",
	};

	export let data = [];
	export let handleSort;

	function toggleSort(column) {
		if (numColumn === column) {
			sort.sortDir = sort.sortDir === 0 ? 1 : 0;
		} else {
			sort.sortDir = 0;
		}
		numColumn = column;
		sort.sortCol = column;
		handleSort(sort);
	}
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th
					>Date Reviewed &nbsp;
					<!-- svelte-ignore a11y-click-events-have-key-events -->
					<!-- svelte-ignore a11y-interactive-supports-focus -->
					<i
						role="button"
						on:click={() => toggleSort(sortDateReported)}
						>{#if sort.sortDir === 0 && numColumn === sortDateReported}
							<img
								src="/assets/icon-sort-up-thin.svg"
								alt="icon-sort-up"
							/>
						{:else}
							<img
								src="/assets/icon-sort-down-thin.svg"
								alt="icon-sort-down"
							/>
						{/if}
					</i></th
				>
				<th>Vehicle No.</th>
				<th>Reviewer </th>
				<th>Verdict</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { concludedAt, plateNo, reviewedBy, results, vehicleId, id }}
				<tr
					on:click={() => {
						navigate(`/issues/damage-validation/${id}`, {
							state: { reviewed: true },
						});
						damageReviewed.set(true);
					}}
				>
					<td>{convert(concludedAt)}</td>
					<td>
						<span
							class="link link-text"
							on:keydown={() => {}}
							on:click={() =>
								navigate(
									`/car-management/details/${vehicleId}`
								)}
						>
							{plateNo}
						</span>
					</td>
					<td>{reviewedBy}</td>
					<td>{@html verdictOptions[results]}</td>
				</tr>
			{/each}
			{#if data.length === 0}
				<td colspan="4" class="text-center">No data to display</td>
			{/if}
		</tbody>
	</Table>
	<Pagination totalRecord={$totalRecords} />
</LoaderContainer>
